import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '../App.vue'
import store from '../store/store.js'
import router from '../router/index.js'
// Импортируем шаблоны
import fullLayouts from '../layouts/full.vue'
import compactLayouts from '../layouts/compact.vue'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component("full", fullLayouts)
Vue.component("compact", compactLayouts)

Vue.use(BootstrapVue);

  new Vue({
    store,    
    router,    
    el: '#app',
    render: h => h(App)
  })

